import { RevealBlock } from "./motion";

const CATS = [
  {
    label: "Everyday Health",
    d: "Proposed unscheduled health essentials for common needs",
    examples: "Pain relief · Allergy · Digestive care · Rehydration",
    img: "/cat_health.png",
  },
  {
    label: "Freshen Up",
    d: "Cleanse, hydrate and reset",
    examples: "CeraVe · Bioderma · Hero Mighty Patch",
    img: "/cat_skincare.png",
  },
  {
    label: "Hair & Grooming",
    d: "Refresh, restyle and stay ready",
    examples: "OGX · Batiste · SlickHair · Gillette",
    img: "/cat_grooming.png",
  },
  {
    label: "Forgotten Essentials",
    d: "The practical items travellers miss",
    examples: "Wipes · Dental care · Period care · First aid",
    img: "/cat_personal.png",
  },
  {
    label: "Family Care",
    d: "Compact essentials for families",
    examples: "Baby wipes · Mini care kits · Children's dental care",
    img: "/cat_women.png",
  },
  {
    label: "Premium Minis",
    d: "A considered travel-size treat",
    examples: "Patchology · Summer Fridays · Sol de Janeiro · Glow Recipe",
    img: "/cat_premium.png",
  },
];

export default function Collection() {
  return (
    <section id="collection" className="relative bg-cream text-ink py-16 md:py-24" data-testid="collection-section">
      <div className="max-w-[1440px] mx-auto px-5 md:px-10">
        <div className="grid grid-cols-12 gap-6 items-end mb-10 md:mb-14">
          <RevealBlock className="col-span-12 md:col-span-5 lg:col-span-4">
            <p className="eyebrow mb-3">Location-ready collection</p>
            <h2 className="font-display font-light text-ink text-3xl sm:text-4xl md:text-5xl leading-[1.05] tracking-tight">
              Built around<br /><span className="text-orange">everyday needs.</span>
            </h2>
            <p className="mt-5 text-ink/65 text-sm md:text-base leading-relaxed max-w-md font-sans">
              Six focused categories for the moments people need help most — led by proposed unscheduled health essentials, then personal care, grooming and practical forgotten items. The assortment is adapted to each location and audience.
            </p>
          </RevealBlock>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-5">
          {CATS.map((c, i) => (
            <RevealBlock
              key={c.label}
              delay={i * 0.05}
              y={22}
              className="card-lift bg-white rounded-2xl overflow-hidden border border-ink/10 shadow-[0_2px_10px_rgba(10,30,68,0.04)] hover:shadow-[0_14px_34px_rgba(10,30,68,0.10)] flex flex-col h-full"
              data-testid={`collection-card-${c.label.toLowerCase().replace(/[^a-z0-9]+/g,'-')}`}
            >
              <div className="relative aspect-square w-full overflow-hidden bg-cream2">
                <img
                  src={c.img}
                  alt={c.label}
                  className="absolute inset-0 w-full h-full object-cover"
                  loading="lazy"
                  onError={(e) => { e.currentTarget.style.opacity = 0.35; }}
                  data-testid={`collection-img-${c.label.toLowerCase().replace(/[^a-z0-9]+/g,'-')}`}
                />
              </div>
              <div className="px-4 py-4 md:py-5 text-center flex-1 flex flex-col">
                <h3 className="font-semibold text-ink text-[15px] md:text-base leading-tight">{c.label}</h3>
                <p className="mt-1.5 text-ink/55 text-xs leading-snug">{c.d}</p>
                <p className="mt-3 text-orange-deep text-[11px] leading-snug font-medium mt-auto pt-2">{c.examples}</p>
              </div>
            </RevealBlock>
          ))}
        </div>

        <RevealBlock delay={0.15} className="mt-8 md:mt-10">
          <p className="text-ink/50 text-[11px] md:text-xs italic leading-relaxed max-w-4xl font-sans">
            Indicative product range shown for visualisation purposes only. Any therapeutic good is proposed only as an exact unscheduled SKU and remains subject to pack-and-label verification, written Victorian vending consent, supplier availability and location approval. Scheduled medicines will not be stocked. Brand references are illustrative and do not imply endorsement or supplier approval.
          </p>
        </RevealBlock>
      </div>
    </section>
  );
}
